import React, {Component} from "react";
import {Link} from "react-router";
import TopNav from "../common/nav/TopNav";
import Footer from "../common/Footer";
import PageBlock from "../common/PageBlock"
import AuthBox from "../common/AuthBox"
import {currentSiteName} from "../service/SiteService";

class Register extends Component {
    render() {
        return (
            <div>
                <TopNav tab="register" title="Register"/>

                <PageBlock>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">Join {currentSiteName} today.</h1>
                            </div>
                        </div>

                        <div className="row">
                            <AuthBox className="col-sm-8 col-md-6 col-lg-4" mode="register" />
                        </div>

                        <div className="row m-t">
                            <div className="col-sm-8 col-md-6 col-lg-4">
                                <p>Have an account? <Link to="/login">Log in »</Link></p>
                            </div>
                        </div>
                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default Register;



// WEBPACK FOOTER //
// ./src/modules/views/Register.js